// routes.js
import Error404 from "@/pages/Error404";
import RecordsList from "@/pages/RecordsList";
import { RecordProviders } from "@/pages/RecordsList/providers/RecordsProvider";
import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import LayoutWithProviders from "./providers";
import { FallbackScreen } from "./fallback";
import { getLanguage } from "@/storage/language";

const MeetingRecord = lazy(() => import("@/pages/MeetingRecord"));
const ExportMeeting = lazy(() => import("@/pages/ExportMeeting"));
const MeetingEdit = lazy(() => import("@/pages/MeetingEdit"));
const Settings = lazy(() => import("@/pages/Settings"));

const currentLanguage = getLanguage();

export const routes = [
  {
    path: "/",
    element: <Navigate to={`/${currentLanguage}`} />,
  },
  {
    path: ":lang",
    element: <LayoutWithProviders />,
    children: [
      {
        index: true,
        element: (
          <RecordProviders>
            <RecordsList />
          </RecordProviders>
        ),
      },
      {
        path: "recording/:recordingUUID",
        element: (
          <Suspense fallback={<FallbackScreen />}>
            <MeetingRecord />
          </Suspense>
        ),
      },
      {
        path: "editing/:meetingId",
        element: (
          <Suspense fallback={<FallbackScreen />}>
            <MeetingEdit />
          </Suspense>
        ),
      },
      {
        path: "export/:type/:meetingId/:exportId",
        element: (
          <Suspense fallback={<FallbackScreen />}>
            <ExportMeeting />
          </Suspense>
        ),
      },
      {
        path: "settings",
        element: (
          <Suspense fallback={<FallbackScreen />}>
            <Settings />
          </Suspense>
        ),
      },
      { path: "agenda/:agendaId", element: <Navigate to="/" replace /> },
      { path: "agenda", element: <Navigate to="/" replace /> },
      { path: "*", element: <Error404 /> },
    ],
  },
  { path: "agenda/:agendaId", element: <Navigate to="/" replace /> },
  { path: "agenda", element: <Navigate to="/" replace /> },
  { path: "404", element: <Error404 /> },
  { path: "*", element: <Navigate to="/en" replace /> },
];
